import { AnalyticsUI } from 'features'

const Analytics = () => {
  return (
    <div>
      <AnalyticsUI />
    </div>
  )
}

export { Analytics }
